module.exports = __webpack_public_path__ + "static/media/deleveryIcon.1eab46b1.png";